import { AppBar, Button, Container, Drawer, IconButton, Toolbar, Typography, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAccessToken } from '../Store/slices/authSlice';

const Navbar = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const menuObject = [
        {
            name: 'Dashboard',
            path: '/dashboard'
        },
        {
            name: 'Recipes',
            path: '/recipes'
        },
        {
            name: 'Blogs',
            path: '/blogs'
        },
        {
            name: 'QnA',
            path: '/qna'
        },
        {
            name: 'Settings',
            path: '/settings'
        },
        {
            name: 'Tags',
            path: '/tags'
        },
    ]

    const logoutHandler = () => {
        dispatch(setAccessToken(''));
        navigate('/');
    };

    const toggleDrawer = (open: any) => (event: any) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        setIsDrawerOpen(open);
    };

    return (
        <>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <div
                            onClick={toggleDrawer(true)}
                            style={{
                                cursor: 'pointer',
                                marginRight: '16px',
                                display: { xs: 'block', sm: 'none' } as any
                            }}>
                            <MenuIcon />
                        </div>
                        <Typography
                            variant="h6"
                            component="div"
                            sx={{
                                flexGrow: 1
                            }}>
                            Prenatal Diet
                        </Typography>
                    </Toolbar>
                </Container>
            </AppBar>
            <Drawer
                anchor="left"
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: 200,
                        boxSizing: 'border-box',
                    },
                    '& .MuiDrawer-root': {
                        zIndex: 1000,
                    },
                }}
            >
                <List>
                    {menuObject.map((page, index) => (
                        <ListItem
                            button
                            onClick={() => navigate(page.path)}>
                            <ListItemText primary={page.name} />
                        </ListItem>
                    ))}
                    <ListItem
                        button
                        onClick={logoutHandler}>
                        <ListItemText primary="Logout" />
                    </ListItem>
                </List>
            </Drawer>
        </>
    );
};

export default Navbar;